export const findArrayChange = (newData: any = [], oldData: any = []) => {
  const lookup = { add: [], remove: [] }
  // Go over the new array to see what has been added
  newData.forEach((key: string | number) => {
    if (!oldData.includes(key)) lookup.add.push(key)
  })
  // Go over the old array to see what has been removed
  oldData.forEach((key: string | number) => {
    if (!newData.includes(key)) lookup.remove.push(key)
  })
  return lookup
}

export const isValue = (value: any) => {
  if (value === 0) return true
  return !!value && value !== 'undefined' && value !== 'null'
}

export const formatNumber = (value: number, decimal: number = 0, locale?: string) => {
  return Number(value).toLocaleString(locale, {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  })
}

export const extractFileName = (url: string) => {
  return url?.split("/")?.pop()?.split("?")[0];
}

// Read the payload of a JWT without verifying it, the backend does that
export const decodeToken = (token?: string): Record<string, unknown> | undefined => {
  try {
    const payload = token?.split('.')[1]
    if (!payload) return undefined
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
  } catch {
    return undefined
  }
}
